import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-help",
  "use": "icon-help-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-help\"><path d=\"M512 85.333c235.648 0 426.667 191.019 426.667 426.667S747.648 938.667 512 938.667 85.333 747.648 85.333 512 276.352 85.333 512 85.333zm0 85.334c-188.416 0-341.333 152.917-341.333 341.333S323.584 853.333 512 853.333 853.333 700.416 853.333 512 700.416 170.667 512 170.667zm0 213.333c-58.88 0-106.666 47.787-106.666 106.667h85.333c0-11.734 9.6-21.334 21.333-21.334s21.334 9.6 21.334 21.334c0 21.333-21.334 42.666-42.667 42.666-58.88 0-106.667 47.786-106.667 106.666v42.667h85.334v-42.667c0-11.733 9.6-21.333 21.333-21.333 35.2 0 64-28.8 64-64 0-58.88-47.787-106.667-106.667-106.667zm42.667 256v85.333h-85.334v-85.333h85.334z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/help.svg
// module id = 35H+
// module chunks = 29